
import { httpservice } from '../services';
import { constants } from '../constant/constant';
import {ENTITY} from '../constant';
import {httpserviceWithMultipart} from "../services/HttpServices";
import {JOURNAL_ENTRIES} from '../constant/actionTypes';
let apiEndPoint = constants.ADMIN_URL;

export const doJournalEntriesCreate = data => {
    return httpserviceWithMultipart('post', data, `${apiEndPoint}${constants.API.JOURNAL_ENTRIES}`)
        .then( (response) => {
            console.log(response)

            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });

};

export const doJournalEntriesDelete = Id => {
    const endPointUri = constants.API.JOURNAL_ENTRIES_BY_ID.replace(ENTITY.JOURNAL_ENTRIES_ID, Id);
    return httpservice()
        .delete(endPointUri)
        .then(function (response) {
            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });
};

export const doJournalEntriesUpdate = (Id, data) => {
    const endPointUri = constants.API.JOURNAL_ENTRIES_BY_ID.replace(ENTITY.JOURNAL_ENTRIES_ID, Id);
    
    return httpserviceWithMultipart('put', data, `${apiEndPoint}${endPointUri}` )
        .then(function (response) {
            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });
};
